import { globalizeSelectors } from '../Utils';
import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import { createSingleDataReducer, singleDataType } from '../factories/ApiCall';
import type {
  PosAppPermissionsAction,
  PosAppPermissionsData,
  PosAppPermissionsState,
} from '../types/PosAppPermissions';
/**
 * Just a simple flag to notify the UI that progress modal needs to be shown!
 */

/*
 * action types
 */

const types = {
  GET_STATE: 'STATE/GET_STATE',
  RE_START_AS_ADMIN: 'STATE/RE_START_AS_ADMIN',
} as const;

/*
 * action creators
 */

const actions = {
  getState: (): PosAppPermissionsAction => ({
    type: types.GET_STATE,
  }),
  reStartAsAdmin: (): PosAppPermissionsAction => ({
    type: types.RE_START_AS_ADMIN,
  }),
};
const mountPath = 'pos_app_permissions'; // mount point in global state, must match root reducer

/**
 * Handling login and log out site actions
 */

const reducer = combineReducers({
  permissions: createSingleDataReducer<PosAppPermissionsData>(types.GET_STATE),
}) as (
  state: PosAppPermissionsState | undefined,
  action: PosAppPermissionsAction
) => PosAppPermissionsState;

const propType = PropTypes.shape({
  permissions: singleDataType, // Notify user about the connection lost / recovered to online
});

// selectors

const localSelectors = {
  permissions: (
    state: PosAppPermissionsState
  ): PosAppPermissionsState['permissions'] => state.permissions,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export {
  types as actionTypes,
  actions as default,
  selectors,
  reducer,
  propType,
};
